import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api2 from "../../../Component/axios_Interceptor/api2";
import { useToken } from "../../../Component/Context/useToken";
import { Live } from "../../../Component/Interface/Live";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import { Icon, RowView2 } from "../../../Component/style/common_style";
import PagingControl from "../../../Component/UI/PagingControl";
import icon_order_by_black from "../../../Image/ic_order_by_black.png";
import api from "../../../Component/axios_Interceptor/api";

const Livelist_mobile = () => {
  const { logout } = useToken();
  const Navigate = useNavigate();

  const [cnt, setCnt] = useState(0);
  const [livelist, setLivelist] = useState<Live[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, set_Sort] = useState(false);

  const Order_Change = () => set_Sort(!sort);

  const get_live_list = async () => {
    try {
      const res = await api.get(url.Communication_url.get_live_list, {
        params: {
          currentPage: currentPage,
          perPage: 10,
          sort: sort ? "DESC" : "ASC",
        },
      });
      setLivelist(res.data.liveList || []);
      setCnt(res.data.total || 0);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  useEffect(() => {
    get_live_list();
  }, [currentPage, sort]);

  // 요일 반환
  const Dow = (date: string) => {
    const idx = new Date(date).getDay();
    return ["일", "월", "화", "수", "목", "금", "토"][idx];
  };

  return (
    <Container>
      <Topbar className="end">
        <div onClick={() => logout("ok")}>로그아웃</div>
      </Topbar>

      <TitleArea>
        <div>라이브 목록</div>
        <Order_Btn onClick={Order_Change}>
          {sort ? "오름차순" : "내림차순"}&nbsp;
          <Icon src={icon_order_by_black} />
        </Order_Btn>
      </TitleArea>

      {livelist.map((data, idx) => {
        const date = data.live_start.slice(0, 10);
        const time = data.live_start.slice(11, 16);
        const liveStart = new Date(data.live_start);
        const liveFinish = new Date(data.live_finish);
        const timeDifference = liveFinish.getTime() - liveStart.getTime();
        const hour = timeDifference / (1000 * 60 * 60);
        return (
          <List key={idx}>
            <RowView2 className="row">
              <span className="long">예약일시</span>
              <div>
                {date.replaceAll("-", ".")}({Dow(date)}) {time}
              </div>
            </RowView2>
            <RowView2 className="row">
              <span>라이브 제목</span>
              <div>{data.live_title}</div>
            </RowView2>
            <RowView2 className="row">
              <span>라이브 시간</span>
              <div>{hour}시간</div>
            </RowView2>
            <RowView2 className="row">
              <span className="long">수용인원</span>
              <div>{data.live_limit}명</div>
            </RowView2>
            <RowView2 className="row">
              <span>라이브 상태</span>
              <div>{data.live_status}</div>
            </RowView2>
            {moment(data.live_start).format("YYYY_MM_DD HH:mm:ss") <
              moment(new Date()).format("YYYY_MM_DD HH:mm:ss") &&
              moment(data.live_finish).format("YYYY_MM_DD HH:mm:ss") >
                moment(new Date()).format("YYYY_MM_DD HH:mm:ss") && (
                <RowView2 className="end">
                  <Btn
                    className="red"
                    onClick={() => Navigate(`Live_manage/${data.seq}`)}
                  >
                    라이브 송출
                  </Btn>
                </RowView2>
              )}
          </List>
        );
      })}
      <PagingControl
        cnt={cnt}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        perPage={10}
      />
    </Container>
  );
};

export default Livelist_mobile;

const Container = styled.div`
  padding: 4rem 1rem 1rem 1rem;
  ${fontStyles.regular}
`;
const Topbar = styled(RowView2)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3rem;
  background-color: white;
  border-bottom: 1px solid #f0f0f0;
  div {
    padding: 0.4rem 1rem;
    margin-right: 1rem;
    font-size: 14px;
    color: #8e8e8e;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
  }
`;
const TitleArea = styled.div`
  display: flex;
  ${fontStyles.semiBold};
  font-size: 20px;
  justify-content: space-between;
  align-items: center;
`;
const List = styled.div`
  padding: 1.5rem 0rem;
  border-bottom: 2px solid #f8f8f8;
  .row {
    margin-bottom: 0.5rem;
    align-items: flex-start;
  }
  .row > span {
    width: 5rem;
    min-width: 5rem;
    color: #8e8e8e;
    margin-right: 0.5rem;
  }
  .row > span.long {
    letter-spacing: 6px;
  }
  .row > div {
    ${fontStyles.medium}
  }
`;
const Btn = styled.div`
  padding: 0.5rem 1rem;
  ${fontStyles.medium}
  font-size: 14px;
  border-radius: 8px;
  color: #8e8e8e;
  border: 1px solid #f0f0f0;
  &.red {
    color: #ea2922;
    border: 1px solid #ea2922;
  }
`;
const Order_Btn = styled.div`
  padding: 0.5rem 1rem;
  ${fontStyles.medium}
  font-size: 14px;
  border-radius: 8px;
  color: #2d2d2d;
  border: 1px solid #f0f0f0;
  display: flex;
`;
